import { createContext, useState, useEffect, useContext } from "react";
import en from "./locales/en.json";
import tr from "./locales/tr.json";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("tr");

  const translations = {
    en,
    tr
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(savedLanguage);
    } else {
      setLanguage("tr");
      localStorage.setItem("language", "tr");
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  const getTranslation = (key, params = {}) => {
    if (translations[language]) {
      let translation = translations[language][key] || key;

      Object.keys(params).forEach((paramKey) => {
        translation = translation.replace(
          new RegExp(`\\{${paramKey}\\}`, "g"),
          params[paramKey]
        );
      });

      return translation;
    }
    return key;
  };

  return (
    <LanguageContext.Provider
      value={{ language, changeLanguage, translations, getTranslation }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
